const API_MAP = {
  '/login': '/auth/login',

  '/opd-type-list': '/opd-type/list',
  '/opd-type-create': '/opd-type/create',
  '/opd-type-update': '/opd-type/update',
  '/opd-type-delete': '/opd-type/delete',
  '/opd-type-cancel': '/opd-type/cancel',
  '/opd-type-dropdown': '/opd-type/dropdown',

  '/state-list': '/state/list',
  '/state-create': '/state/create',
  '/state-update': '/state/update',
  '/state-cancel': '/state/cancel',
  '/state-delete': '/state/delete',
  '/state-dropdown': '/state/dropdown',

  '/city-list': '/city/list',
  '/city-create': '/city/create',
  '/city-update': '/city/update',
  '/city-cancel': '/city/cancel',
  '/city-delete': '/city/delete',
  '/city-dropdown': '/city/dropdown',

  '/user-list': '/user-management/list',
  '/user-create': '/user-management/create',
  '/user-update': '/user-management/update',
  '/user-delete': '/user-management/delete',

  '/role-master-list': '/role-master/list',
  '/role-master-create': '/role-master/create',
  '/role-master-update': '/role-master/update',
  '/role-master-delete': '/role-master/delete',
  '/role-dropdown': '/role/dropdown',

  '/admin-type-list': '/admin-type/list',
  '/admin-type-create': '/admin-type/create',
  '/admin-type-update': '/admin-type/update',
  '/admin-type-delete': '/admin-type/delete',
  '/admin-type-dropdown': '/admin-type/dropdown',

  '/nursing-station-list': '/nursing-station/list',
  '/nursing-station-create': '/nursing-station/create',
  '/nursing-station-update': '/nursing-station/update',
  '/nursing-station-cancel': '/nursing-station/cancel',
  '/nursing-station-delete': '/nursing-station/delete',
  '/nursing-station-dropdown': '/nursing-station/dropdown',

  '/floor-list': '/floor/list',
  '/floor-create': '/floor/create',
  '/floor-update': '/floor/update',
  '/floor-cancel': '/floor/cancel',
  '/floor-delete': '/floor/delete',
  '/floor-dropdown': '/floor/dropdown',

  '/ward-list': '/ward/list',
  '/ward-create': '/ward/create',
  '/ward-update': '/ward/update',
  '/ward-cancel': '/ward/cancel',
  '/ward-delete': '/ward/delete',
  '/ward-dropdown': '/ward/dropdown',

  '/room-master-list': '/room-master/list',
  '/room-master-create': '/room-master/create',
  '/room-master-update': '/room-master/update',
  '/room-master-cancel': '/room-master/cancel',
  '/room-master-delete': '/room-master/delete',
  '/room-master-dropdown': '/room-master/dropdown',
  '/bed-status-percent-list': '/bed-status-percent/list',

  '/ward-category-list': '/ward-category/list',
  '/ward-category-create': '/ward-category/create',
  '/ward-category-update': '/ward-category/update',
  '/ward-category-cancel': '/ward-category/cancel',
  '/ward-category-delete': '/ward-category/delete',
  '/ward-category-dropdown': '/ward-category/dropdown',

  '/emr-main-group-list': '/emr-main-group/list',
  '/emr-main-group-create': '/emr-main-group/create',
  '/emr-main-group-update': '/emr-main-group/update',
  '/emr-main-group-delete': '/emr-main-group/delete',
  '/emr-main-group-dropdown': '/emr-main-group/dropdown',

  '/department-unit-list': '/department-unit/list',
  '/department-unit-create': '/department-unit/create',
  '/department-unit-update': '/department-unit/update',
  '/department-unit-cancel': '/department-unit/cancel',
  '/department-unit-delete': '/department-unit/delete',
  '/department-unit-dropdown': '/department-unit/dropdown',

  '/department-unit-head-list': '/department-unit-head/list',
  '/department-unit-head-create': '/department-unit-head/create',
  '/department-unit-head-update': '/department-unit-head/update',
  '/department-unit-head-cancel': '/department-unit-head/cancel',
  '/department-unit-head-delete': '/department-unit-head/delete',
  '/department-unit-head-dropdown': '/department-unit-head/dropdown',

  '/patient-type-list': '/patient-type/list',
  '/patient-type-create': '/patient-type/create',
  '/patient-type-update': '/patient-type/update',
  '/patient-type-delete': '/patient-type/delete',
  '/patient-type-dropdown': '/patient-type/dropdown',

  '/relation-master-list': '/relation-master/list',
  '/relation-master-create': '/relation-master/create',
  '/relation-master-update': '/relation-master/update',
  '/relation-master-delete': '/relation-master/delete',
  '/relation-master-cancel': '/relation-master/cancel',
  '/relation-master-dropdown': '/relation-master/dropdown',

  '/department-list': '/department/list',
  '/department-create': '/department/create',
  '/department-update': '/department/update',
  '/department-cancel': '/department/cancel',
  '/department-delete': '/department/delete',
  '/department-dropdown': '/department/dropdown',

  '/location-master-list': '/location-master/list',
  '/location-master-create': '/location-master/create',
  '/location-master-update': '/location-master/update',
  '/location-master-cancel': '/location-master/cancel',
  '/location-master-delete': '/location-master/delete',
  '/location-master-dropdown': '/location-master/dropdown',

  '/speciality-master-list': '/speciality-master/list',
  '/speciality-master-create': '/speciality-master/create',
  '/speciality-master-update': '/speciality-master/update',
  '/speciality-master-cancel': '/speciality-master/cancel',
  '/speciality-master-delete': '/speciality-master/delete',
  '/speciality-master-dropdown': '/speciality-master/dropdown',

  '/feegroup-master-list': '/feegroup-master/list',
  '/feegroup-master-create': '/feegroup-master/create',
  '/feegroup-master-update': '/feegroup-master/update',
  '/feegroup-master-cancel': '/feegroup-master/cancel',
  '/feegroup-master-delete': '/feegroup-master/delete',
  '/feegroup-master-dropdown': '/feegroup-master/dropdown',

  '/vertical-master-list': '/vertical-master/list',
  '/vertical-master-create': '/vertical-master/create',
  '/vertical-master-update': '/vertical-master/update',
  '/vertical-master-cancel': '/vertical-master/cancel',
  '/vertical-master-delete': '/vertical-master/delete',
  '/vertical-master-dropdown': '/vertical-master/dropdown',

  '/group-master-list': '/group-master/list',
  '/group-master-create': '/group-master/create',
  '/group-master-update': '/group-master/update',
  '/group-master-cancel': '/group-master/cancel',
  '/group-master-delete': '/group-master/delete',
  '/group-master-dropdown': '/group-master/dropdown',

  '/subgroup-master-list': '/subgroup-master/list',
  '/subgroup-master-create': '/subgroup-master/create',
  '/subgroup-master-update': '/subgroup-master/update',
  '/subgroup-master-cancel': '/subgroup-master/cancel',
  '/subgroup-master-delete': '/subgroup-master/delete',
  '/subgroup-master-dropdown': '/subgroup-master/dropdown',
  '/subgroup-master-bygroup-list': '/subgroup-master-bygroup/list',

  '/reason-master-list': '/reason-master/list',
  '/reason-master-create': '/reason-master/create',
  '/reason-master-update': '/reason-master/update',
  '/reason-master-cancel': '/reason-master/cancel',
  '/reason-master-delete': '/reason-master/delete',
  '/reason-master-dropdown': '/reason-master/dropdown',

  '/flutype-master-list': '/flutype-master/list',
  '/flutype-master-create': '/flutype-master/create',
  '/flutype-master-update': '/flutype-master/update',
  '/flutype-master-cancel': '/flutype-master/cancel',
  '/flutype-master-delete': '/flutype-master/delete',
  '/flutype-master-dropdown': '/flutype-master/dropdown',

  '/emergency-master-list': '/emergency-master/list',
  '/emergency-master-create': '/emergency-master/create',
  '/emergency-master-update': '/emergency-master/update',
  '/emergency-master-delete': '/emergency-master/delete',
  '/emergency-master-dropdown': '/emergency-master/dropdown',

  '/rank-master-list': '/rank-master/list',
  '/rank-master-create': '/rank-master/create',
  '/rank-master-update': '/rank-master/update',
  '/rank-master-delete': '/rank-master/delete',
  '/rank-master-dropdown': '/rank-master/dropdown',

  '/doctor-unit-list': '/doctor-unit/list',
  '/doctor-unit-create': '/doctor-unit/create',
  '/doctor-unit-update': '/doctor-unit/update',
  '/doctor-unit-cancel': '/doctor-unit/cancel',
  '/doctor-unit-delete': '/doctor-unit/delete',
  '/doctor-unit-dropdown': '/doctor-unit/dropdown',

  '/doctor-create': '/doctor/create',
  '/doctor-update': '/doctor/update',
  '/doctor-cancel': '/doctor/cancel',
  '/doctor-delete': '/doctor/delete',
  '/doctor-list': '/doctor/list',
  '/doctor-dropdown': '/doctor/dropdown',
  '/doctor-surgeon-dropdown': '/doctor-surgeon/dropdown',

  '/doctor-fee-setup-create': '/doctor-fee-setup/create',
  '/doctor-fee-setup-update': '/doctor-fee-setup/update',
  '/doctor-fee-setup-cancel': '/doctor-fee-setup/cancel',
  '/doctor-fee-setup-delete': '/doctor-fee-setup/delete',
  '/doctor-fee-setup-list': '/doctor-fee-setup/list',
  '/doctor-fee-setup-dropdown': '/doctor-fee-setup/dropdown',

  '/sponsor-create': '/sponsor/create',
  '/sponsor-update': '/sponsor/update',
  '/sponsor-cancel': '/sponsor/cancel',
  '/sponsor-delete': '/sponsor/delete',
  '/sponsor-list': '/sponsor/list',
  '/sponsor-dropdown': '/sponsor/dropdown',

  '/discount-create': '/discount/create',
  '/discount-update': '/discount/update',
  '/discount-cancel': '/discount/cancel',
  '/discount-delete': '/discount/delete',
  '/discount-list': '/discount/list',
  '/discount-dropdown': '/discount/dropdown',

  '/control-unit-create': '/control-unit/create',
  '/control-unit-update': '/control-unit/update',
  '/control-unit-cancel': '/control-unit/cancel',
  '/control-unit-delete': '/control-unit/delete',
  '/control-unit-list': '/control-unit/list',
  '/control-unit-dropdown': '/control-unit/dropdown',

  '/referral-create': '/referral/create',
  '/referral-update': '/referral/update',
  '/referral-cancel': '/referral/cancel',
  '/referral-delete': '/referral/delete',
  '/referral-list': '/referral/list',
  '/referral-dropdown': '/referral/dropdown',

  '/patient-list': '/patient/list',
  '/patient-create': '/patient/create',
  '/patient-update': '/patient/update',
  '/patient-delete': '/patient/delete',
  '/patient-dropdown': '/patient/dropdown',

  '/service-list': '/service/list',
  '/service-bysubgroup-list': '/service-bysubgroup/list',
  '/service-create': '/service/create',
  '/service-update': '/service/update',
  '/service-cancel': '/service/cancel',
  '/service-delete': '/service/delete',
  '/service-dropdown': '/service/dropdown',

  '/scheme-create': '/scheme/create',
  '/scheme-list': '/scheme/list',
  '/scheme-update': '/scheme/update',
  '/scheme-cancel': '/scheme/cancel',
  '/scheme-delete': '/scheme/delete',
  '/scheme-dropdown': '/scheme/dropdown',

  '/patient-registeration-create': '/patient-registeration/create',
  '/patient-registeration-list': '/patient-registeration/list',
  '/patient-registeration-today-list': '/patient-registeration-today/list',
  '/patient-registeration-queue-display-list': '/patient-registeration-queue-display/list',
  '/patient-registeration-gynae-list': '/patient-registeration-gynae/list',
  '/patient-registeration-update': '/patient-registeration/update',
  '/patient-registeration-call-in': '/patient-registeration/call-in',
  '/patient-registeration-done': '/patient-registeration/done',
  '/patient-registeration-defer': '/patient-registeration/defer',
  '/patient-registeration-revert': '/patient-registeration/revert',
  '/patient-registeration-done-list': '/patient-registeration-done/list',
  '/patient-registeration-defer-list': '/patient-registeration-defer/list',
  '/patient-registeration-cancel': '/patient-registeration/cancel',
  '/patient-registeration-delete': '/patient-registeration/delete',
  '/patient-registeration-search': '/patient-registeration/details',
  '/patient-registeration-print': '/patient-registeration/print',
  '/patient-registeration-searchdetail': '/patient-registeration/searchdetail',

  '/indoor-registeration-create': '/indoor-registeration/create',
  '/indoor-registeration-list': '/indoor-registeration/list',
  '/indoor-registeration-list-admit-patient': '/indoor-registeration-admit-patient/list',
  '/indoor-registeration-today-discharge-list': '/indoor-registeration-today-discharge/list',
  '/indoor-registeration-today-admit-list': '/indoor-registeration-today-admit/list',
  '/indoor-registeration-update': '/indoor-registeration/update',
  '/indoor-registeration-cancel': '/indoor-registeration/cancel',
  '/indoor-registeration-delete': '/indoor-registeration/delete',
  '/indoor-registeration-detail': '/indoor-registeration/detail',
  '/indoor-registeration-detail-list': '/indoor-registeration/detail-list',
  '/indoor-registeration-summary-detail-list': '/indoor-registeration-summary/detail-list',
  '/indoor-registeration-all-detail-list': '/indoor-registeration-all/detail-list',
  '/indoor-registeration-bill-detail-list': '/indoor-registeration-bill/detail-list',
  '/indoor-registeration-check-uhid': '/indoor-registeration/check-uhid',
  '/indoor-registeration-status': '/indoor-registeration/status',
  '/indoor-registeration-latest-ipd': '/indoor-registeration-latest-ipd',

  '/opd-billing-create': '/opd-billing/create',
  '/opd-billing-list': '/opd-billing/list',
  '/opd-billing-active-service-list': '/opd-billing-active-service/list',
  '/opd-billing-radiology-list': '/opd-billing-radiology/list',
  '/opd-billing-investigation-list': '/opd-billing-investigation/list',
  '/opd-billing-cancel': '/opd-billing/cancel',
  '/opd-billing-delete': '/opd-billing/delete',
  '/opd-billing-edit': '/opd-billing/edit',

  '/ipd-billing-create': '/ipd-billing/create',
  '/ipd-billing-list': '/ipd-billing/list',
  '/ipd-billing-active-service-list': '/ipd-billing-active-service/list',
  '/ipd-billing-radiology-list': '/ipd-billing-radiology/list',
  '/ipd-billing-investigation-list': '/ipd-billing-investigation/list',
  '/ipd-billing-cancel': '/ipd-billing/cancel',
  '/ipd-billing-delete': '/ipd-billing/delete',
  '/ipd-billing-edit': '/ipd-billing/edit',
  '/ipd-billing-update': '/ipd-billing/update',
  '/ipd-billing-service-inactive': '/ipd-billing/service-inactive',
  '/ipd-billing-service-add': '/ipd-billing/service-add',
  '/ipd-billing-balance': '/ipd-billing/balance',

  '/receipt-voucher-create': '/receipt-voucher/create',
  '/receipt-voucher-list': '/receipt-voucher/list',
  '/receipt-voucher-update': '/receipt-voucher/update',
  '/receipt-voucher-delete': '/receipt-voucher/delete',

  '/payment-refund-voucher-create': '/payment-refund-voucher/create',
  '/payment-refund-voucher-list': '/payment-refund-voucher/list',
  '/payment-refund-voucher-update': '/payment-refund-voucher/update',
  '/payment-refund-voucher-delete': '/payment-refund-voucher/delete',



  '/gate-pass-create': '/gate-pass/create',
  '/gate-pass-list': '/gate-pass/list',
  '/gate-pass-today-list': '/gate-pass/today/list',
  '/gate-pass-by-id': '/gate-pass/:id',
  '/gate-pass-by-ipd': '/gate-pass/ipd/:ipd_no',
  '/gate-pass-update': '/gate-pass',
  '/gate-pass-mark-used': '/gate-pass/mark-used',
  '/gate-pass-mark-printed': '/gate-pass/:id/mark-printed',
  // Delete
  '/gate-pass-delete': '/gate-pass/:id',
  // Statistics
  '/gate-pass-statistics': '/gate-pass/statistics',
  // Generate Number
  '/gate-pass-generate-number': '/gate-pass/generate-number',


  '/test-main-group-list': '/test-main-group/list',
  '/test-main-group-create': '/test-main-group/create',
  '/test-main-group-update': '/test-main-group/update',
  '/test-main-group-cancel': '/test-main-group/cancel',
  '/test-main-group-delete': '/test-main-group/delete',
  '/test-main-group-dropdown': '/test-main-group/dropdown',

  '/test-sub-group-list': '/test-sub-group/list',
  '/test-sub-group-create': '/test-sub-group/create',
  '/test-sub-group-update': '/test-sub-group/update',
  '/test-sub-group-cancel': '/test-sub-group/cancel',
  '/test-sub-group-delete': '/test-sub-group/delete',
  '/test-sub-group-dropdown': '/test-sub-group/dropdown',

  '/category-list': '/category/list',
  '/category-create': '/category/create',
  '/category-update': '/category/update',
  '/category-cancel': '/category/cancel',
  '/category-delete': '/category/delete',
  '/category-dropdown': '/category/dropdown',

  '/specimen-list': '/specimen/list',
  '/specimen-create': '/specimen/create',
  '/specimen-update': '/specimen/update',
  '/specimen-cancel': '/specimen/cancel',
  '/specimen-delete': '/specimen/delete',
  '/specimen-dropdown': '/specimen/dropdown',





  '/tube-type-list': '/tube-type/list',
  '/tube-type-create': '/tube-type/create',
  '/tube-type-update': '/tube-type/update',
  '/tube-type-cancel': '/tube-type/cancel',
  '/tube-type-delete': '/tube-type/delete',
  '/tube-type-dropdown': '/tube-type/dropdown',

  '/out-source-lab-list': '/out-source-lab/list',
  '/out-source-lab-create': '/out-source-lab/create',
  '/out-source-lab-update': '/out-source-lab/update',
  '/out-source-lab-delete': '/out-source-lab/delete',
  '/out-source-lab-dropdown': '/out-source-lab/dropdown',

  '/diagnosis-list': '/diagnosis/list',
  '/diagnosis-create': '/diagnosis/create',
  '/diagnosis-update': '/diagnosis/update',
  '/diagnosis-delete': '/diagnosis/delete',
  '/diagnosis-dropdown': '/diagnosis/dropdown',

  '/lis-reason-list': '/lis-reason/list',
  '/lis-reason-create': '/lis-reason/create',
  '/lis-reason-update': '/lis-reason/update',
  '/lis-reason-delete': '/lis-reason/delete',
  '/lis-reason-dropdown': '/lis-reason/dropdown',

  '/lis-remarks-list': '/lis-remarks/list',
  '/lis-remarks-create': '/lis-remarks/create',
  '/lis-remarks-update': '/lis-remarks/update',
  '/lis-remarks-delete': '/lis-remarks/delete',
  '/lis-remarks-dropdown': '/lis-remarks/dropdown',

  '/lis-machine-list': '/lis-machine/list',
  '/lis-machine-create': '/lis-machine/create',
  '/lis-machine-update': '/lis-machine/update',
  '/lis-machine-delete': '/lis-machine/delete',
  '/lis-machine-dropdown': '/lis-machine/dropdown',

  '/lis-sensitivity-list': '/lis-sensitivity/list',
  '/lis-sensitivity-create': '/lis-sensitivity/create',
  '/lis-sensitivity-update': '/lis-sensitivity/update',
  '/lis-sensitivity-delete': '/lis-sensitivity/delete',
  '/lis-sensitivity-dropdown': '/lis-sensitivity/dropdown',

  '/lis-antimicrobials-list': '/lis-antimicrobials/list',
  '/lis-antimicrobials-create': '/lis-antimicrobials/create',
  '/lis-antimicrobials-update': '/lis-antimicrobials/update',
  '/lis-antimicrobials-delete': '/lis-antimicrobials/delete',
  '/lis-antimicrobials-dropdown': '/lis-antimicrobials/dropdown',

  '/lis-discount-list': '/lis-discount/list',
  '/lis-discount-create': '/lis-discount/create',
  '/lis-discount-update': '/lis-discount/update',
  '/lis-discount-cancel': '/lis-discount/cancel',
  '/lis-discount-delete': '/lis-discount/delete',
  '/lis-discount-dropdown': '/lis-discount/dropdown',

  '/lis-discount-authority-list': '/lis-discount-authority/list',
  '/lis-discount-authority-create': '/lis-discount-authority/create',
  '/lis-discount-authority-update': '/lis-discount-authority/update',
  '/lis-discount-authority-cancel': '/lis-discount-authority/cancel',
  '/lis-discount-authority-delete': '/lis-discount-authority/delete',
  '/lis-discount-authority-dropdown': '/lis-discount-authority/dropdown',

  '/lis-referral-list': '/lis-referral/list',
  '/lis-referral-create': '/lis-referral/create',
  '/lis-referral-update': '/lis-referral/update',
  '/lis-referral-cancel': '/lis-referral/cancel',
  '/lis-referral-delete': '/lis-referral/delete',
  '/lis-referral-dropdown': '/lis-referral/dropdown',

  '/lab-authority-doctor-list': '/lab-authority-doctor/list',
  '/lab-authority-doctor-create': '/lab-authority-doctor/create',
  '/lab-authority-doctor-update': '/lab-authority-doctor/update',
  '/lab-authority-doctor-cancel': '/lab-authority-doctor/cancel',
  '/lab-authority-doctor-delete': '/lab-authority-doctor/delete',
  '/lab-authority-doctor-dropdown': '/lab-authority-doctor/dropdown',

  '/lis-test-list': '/lis-test/list',
  '/lis-test-create': '/lis-test/create',
  '/lis-test-update': '/lis-test/update',
  '/lis-test-cancel': '/lis-test/cancel',
  '/lis-test-delete': '/lis-test/delete',
  '/lis-test-dropdown': '/lis-test/dropdown',

  '/lis-test-panel-list': '/lis-test-panel/list',
  '/lis-test-panel-create': '/lis-test-panel/create',
  '/lis-test-panel-update': '/lis-test-panel/update',
  '/lis-test-panel-delete': '/lis-test-panel/delete',
  '/lis-test-panel-dropdown': '/lis-test-panel/dropdown',

  '/investigation-booking-create': '/investigation-booking/create',
  '/investigation-booking-list': '/investigation-booking/list',
  '/investigation-booking-cancel': '/investigation-booking/cancel',
  '/investigation-booking-delete': '/investigation-booking/delete',
  '/investigation-booking-edit': '/investigation-booking/edit',
  '/investigation-booking-opd-billing/list': '/investigation-booking-opd-billing/list',

  '/lis-sample-collection-create': '/lis-sample-collection/create',
  '/lis-sample-collection-list': '/lis-sample-collection/list',

  '/patient-discharge-create': '/patient-discharge/create',
  '/patient-discharge-delete': '/patient-discharge/delete',
  '/patient-discharge-update': '/patient-discharge/update',
  '/patient-discharge-list': '/patient-discharge/list',
  '/patient-discharge-request': '/patient-discharge/request',
  '/patient-discharge-request-cancel': '/patient-discharge/request-cancel',

  '/discharge-summary-create': '/discharge-summary/create',
  '/discharge-summary-edit': '/discharge-summary/edit',
  '/discharge-summary-list': '/discharge-summary/list',
  '/discharge-summary-cancel': '/discharge-summary/cancel',
  '/discharge-summary-delete': '/discharge-summary/delete',

  '/consultant-transfer-create': '/consultant-transfer/create',
  '/consultant-transfer-list': '/consultant-transfer/list',
  '/consultant-transfer-edit': '/consultant-transfer/edit',
  '/consultant-transfer-cancel': '/consultant-transfer/cancel',
  '/consultant-transfer-delete': '/consultant-transfer/delete',

  '/auth-logout': '/auth/logout',

  '/lis-result-entry-create': '/lis-result-entry/create',
  '/lis-result-entry-list': '/lis-result-entry/list',
  '/lis-result-entry-single-patient-list': '/lis-result-entry-single-patient/list',
  '/lis-result-entry-single-patient-ipd-list': '/lis-result-entry-single-patient-ipd/list',
  '/lis-result-entry-cancel': '/lis-result-entry/cancel',
  '/lis-result-entry-delete': '/lis-result-entry/delete',
  '/lis-result-entry-update': '/lis-result-entry/update',
  '/lis-result-entry-signature': '/lis-result-entry/signature',
  '/lis-result-entry-details': '/lis-result-entry/details',

  '/final-bill-create': '/final-bill/create',
  '/final-bill-authorise': '/final-bill/authorise',
  '/final-bill-list': '/final-bill/list',
  '/doctor-billing-list': '/doctor-billing/list',

  '/print-layout-create': '/print-layout/create',
  '/print-layout-list': '/print-layout/list',

  '/opd-requisition-create': '/opd-requisition/create',
  '/opd-requisition-list': '/opd-requisition/list',
  '/opd-requisition-saved-list': '/opd-requisition-saved/list',
  '/opd-requisition-cancel': '/opd-requisition/cancel',
  '/opd-requisition-delete': '/opd-requisition/delete',
  '/opd-requisition-edit': '/opd-requisition/edit',

  '/manufacturer-create': '/manufacturer/create',
  '/manufacturer-list': '/manufacturer/list',
  '/manufacturer-update': '/manufacturer/update',
  '/manufacturer-cancel': '/manufacturer/cancel',
  '/manufacturer-delete': '/manufacturer/delete',
  '/manufacturer-dropdown': '/manufacturer/dropdown',

  '/product-category-create': '/product-category/create',
  '/product-category-list': '/product-category/list',
  '/product-category-update': '/product-category/update',
  '/product-category-cancel': '/product-category/cancel',
  '/product-category-delete': '/product-category/delete',
  '/product-category-dropdown': '/product-category/dropdown',

  '/pharmacy-group-create': '/pharmacy-group/create',
  '/pharmacy-group-list': '/pharmacy-group/list',
  '/pharmacy-group-update': '/pharmacy-group/update',
  '/pharmacy-group-dropdown': '/pharmacy-group/dropdown',
  '/pharmacy-group-delete': '/pharmacy-group/delete',
  '/pharmacy-group-cancel': '/pharmacy-group/cancel',

  '/pharmacy-subgroup-create': '/pharmacy-subgroup/create',
  '/pharmacy-subgroup-list': '/pharmacy-subgroup/list',
  '/pharmacy-subgroup-update': '/pharmacy-subgroup/update',
  '/pharmacy-subgroup-dropdown': '/pharmacy-subgroup/dropdown',
  '/pharmacy-subgroup-cancel': '/pharmacy-subgroup/cancel',
  '/pharmacy-subgroup-delete': '/pharmacy-subgroup/delete',

  '/pharmacy-marketed-create': '/pharmacy-marketed/create',
  '/pharmacy-marketed-list': '/pharmacy-marketed/list',
  '/pharmacy-marketed-update': '/pharmacy-marketed/update',
  '/pharmacy-marketed-dropdown': '/pharmacy-marketed/dropdown',
  '/pharmacy-marketed-cancel': '/pharmacy-marketed/cancel',
  '/pharmacy-marketed-delete': '/pharmacy-marketed/delete',

  '/pharmacy-therapeutic-create': '/pharmacy-therapeutic/create',
  '/pharmacy-therapeutic-list': '/pharmacy-therapeutic/list',
  '/pharmacy-therapeutic-update': '/pharmacy-therapeutic/update',
  '/pharmacy-therapeutic-dropdown': '/pharmacy-therapeutic/dropdown',
  '/pharmacy-therapeutic-cancel': '/pharmacy-therapeutic/cancel',
  '/pharmacy-therapeutic-delete': '/pharmacy-therapeutic/delete',

  '/pharmacy-storage-create': '/pharmacy-storage/create',
  '/pharmacy-storage-list': '/pharmacy-storage/list',
  '/pharmacy-storage-update': '/pharmacy-storage/update',
  '/pharmacy-storage-dropdown': '/pharmacy-storage/dropdown',
  '/pharmacy-storage-cancel': '/pharmacy-storage/cancel',
  '/pharmacy-storage-delete': '/pharmacy-storage/delete',

  '/pharmacy-route-create': '/pharmacy-route/create',
  '/pharmacy-route-list': '/pharmacy-route/list',
  '/pharmacy-route-update': '/pharmacy-route/update',
  '/pharmacy-route-dropdown': '/pharmacy-route/dropdown',
  '/pharmacy-route-cancel': '/pharmacy-route/cancel',
  '/pharmacy-route-delete': '/pharmacy-route/delete',

  '/uqc-master-create': '/uqc-master/create',
  '/uqc-master-list': '/uqc-master/list',
  '/uqc-master-update': '/uqc-master/update',
  '/uqc-master-dropdown': '/uqc-master/dropdown',
  '/uqc-master-cancel': '/uqc-master/cancel',
  '/uqc-master-delete': '/uqc-master/delete',

  '/purchase-uom-create': '/purchase-uom/create',
  '/purchase-uom-list': '/purchase-uom/list',
  '/purchase-uom-update': '/purchase-uom/update',
  '/purchase-uom-dropdown': '/purchase-uom/dropdown',
  '/purchase-uom-cancel': '/purchase-uom/cancel',
  '/purchase-uom-delete': '/purchase-uom/delete',

  '/generic-master-create': '/generic-master/create',
  '/generic-master-list': '/generic-master/list',
  '/generic-master-update': '/generic-master/update',
  '/generic-master-dropdown': '/generic-master/dropdown',
  '/generic-master-cancel': '/generic-master/cancel',
  '/generic-master-delete': '/generic-master/delete',

  '/tax-category-master-create': '/tax-category-master/create',
  '/tax-category-master-list': '/tax-category-master/list',
  '/tax-category-master-update': '/tax-category-master/update',
  '/tax-category-master-dropdown': '/tax-category-master/dropdown',
  '/tax-category-master-cancel': '/tax-category-master/cancel',
  '/tax-category-master-delete': '/tax-category-master/delete',

  '/product-master-create': '/product-master/create',
  '/product-master-list': '/product-master/list',
  '/product-master-update': '/product-master/update',
  '/product-master-delete': '/product-master/delete',
  '/product-master-cancel': '/product-master/cancel',
  '/product-master-dropdown': '/product-master/dropdown',
  '/product-master-detailed-dropdown': '/product-master-detailed/dropdown',

  '/warehouse-create': '/warehouse/create',
  '/warehouse-list': '/warehouse/list',
  '/warehouse-update': '/warehouse/update',
  '/warehouse-dropdown': '/warehouse/dropdown',
  '/warehouse-cancel': '/warehouse/cancel',
  '/warehouse-delete': '/warehouse/delete',

  '/consignment-receipt-create': '/consignment-receipt/create',
  '/consignment-receipt-list': '/consignment-receipt/list',
  '/consignment-receipt-supplier-list': '/consignment-receipt-supplier/list',
  '/consignment-receipt-update': '/consignment-receipt/update',
  '/consignment-receipt-cancel': '/consignment-receipt/cancel',
  '/consignment-receipt-delete': '/consignment-receipt/delete',
  '/consignment-receipt-dropdown': '/consignment-receipt/dropdown',
  '/consignment-receipt-unauthorise-dropdown': '/consignment-receipt-unauthorise/dropdown',
  '/consignment-receipt-add-details-dropdown': '/consignment-receipt-add-details/dropdown',

  '/consignment-return-create': '/consignment-return/create',
  '/consignment-return-list': '/consignment-return/list',
  '/consignment-return-update': '/consignment-return/update',
  '/consignment-return-delete': '/consignment-return/delete',
  '/consignment-return-cancel': '/consignment-return/cancel',
  '/consignment-return-dropdown': '/consignment-return/dropdown',

  '/grn-create': '/grn/create',
  '/grn-list': '/grn/list',
  '/grn-update': '/grn/update',
  '/grn-cancel': '/grn/cancel',
  '/grn-delete': '/grn/delete',
  '/grn-dropdown': '/grn/dropdown',
  '/grn-unauthorise-dropdown': '/grn-unauthorise/dropdown',
  '/grn-add-details-dropdown': '/grn/add-details/dropdown',

  '/purchase-return-create': '/purchase-return/create',
  '/purchase-return-list': '/purchase-return/list',
  '/purchase-return-update': '/purchase-return/update',
  '/purchase-return-cancel': '/purchase-return/cancel',
  '/purchase-return-delete': '/purchase-return/delete',

  '/stock-master-create': '/stock-master/create',
  '/stock-master-against-consignment-create': '/stock-master-against-consignment/create',
  '/stock-master-list': '/stock-master/list',
  '/stock-master-total': '/stock-master/total',
  '/stock-master-product-total': '/stock-master-product/total',
  '/stock-master-dropdown': '/stock-master/dropdown',
  '/stock-master-details-dropdown': '/stock-master-details/dropdown',
  '/stock-master-adddetail-dropdown': '/stock-master/adddetail/dropdown',
  '/stock-master-nearest-exp-date-product': '/stock-master-nearest-exp-date/product',

  '/retail-sale-create': '/retail-sale/create',
  '/retail-sale-list': '/retail-sale/list',
  '/retail-sale-update': '/retail-sale/update',
  '/retail-sale-delete': '/retail-sale/delete',
  '/retail-sale-cancel': '/retail-sale/cancel',
  '/retail-sale-opd-credit-list': '/retail-sale-opd-credit/list',
  '/retail-sale-pending-product-list': '/retail-sale-pending-product/list',
  '/retail-sale-ipd-credit-list': '/retail-sale-ipd-credit/list',

  '/retail-sale-return-create': '/retail-sale-return/create',
  '/retail-sale-return-list': '/retail-sale-return/list',
  '/retail-sale-return-update': '/retail-sale-return/update',
  '/retail-sale-return-delete': '/retail-sale-return/delete',
  '/retail-sale-return-cancel': '/retail-sale-return/cancel',

  '/lis-template-create': '/lis-template/create',
  '/lis-template-list': '/lis-template/list',
  '/lis-template-update': '/lis-template/update',
  '/lis-template-cancel': '/lis-template/cancel',
  '/lis-template-delete': '/lis-template/delete',

  '/frequency-master-list': '/frequency-master/list',
  '/frequency-master-create': '/frequency-master/create',
  '/frequency-master-update': '/frequency-master/update',
  '/frequency-master-cancel': '/frequency-master/cancel',
  '/frequency-master-delete': '/frequency-master/delete',
  '/frequency-master-dropdown': '/frequency-master/dropdown',

  '/dose-master-list': '/dose-master/list',
  '/dose-master-create': '/dose-master/create',
  '/dose-master-update': '/dose-master/update',
  '/dose-master-cancel': '/dose-master/cancel',
  '/dose-master-delete': '/dose-master/delete',
  '/dose-master-dropdown': '/dose-master/dropdown',

  '/account-group-create': '/account-group/create',
  '/account-group-list': '/account-group/list',
  '/account-group-update': '/account-group/update',
  '/account-group-cancel': '/account-group/cancel',
  '/account-group-delete': '/account-group/delete',
  '/account-group-dropdown': '/account-group/dropdown',

  '/account-ledger-create': '/account-ledger/create',
  '/account-ledger-list': '/account-ledger/list',
  '/account-ledger-update': '/account-ledger/update',
  '/account-ledger-cancel': '/account-ledger/cancel',
  '/account-ledger-delete': '/account-ledger/delete',
  '/account-ledger-dropdown': '/account-ledger/dropdown',

  '/appointment-create': '/appointment/create',
  '/appointment-list': '/appointment/list',
  '/appointment-not-authorise': '/appointment/not-authorise',
  '/appointment-update': '/appointment/update',
  '/appointment-cancel': '/appointment/cancel',
  '/appointment-delete': '/appointment/delete',
  '/appointment-dropdown': '/appointment/dropdown',
  '/appointment-authorize': '/appointment/authorize',

  '/discharge-mode-create': '/discharge-mode/create',
  '/discharge-mode-list': '/discharge-mode/list',
  '/discharge-mode-update': '/discharge-mode/update',
  '/discharge-mode-cancel': '/discharge-mode/cancel',
  '/discharge-mode-delete': '/discharge-mode/delete',
  '/discharge-mode-dropdown': '/discharge-mode/dropdown',

  '/room-transfer-create': '/room-transfer/create',
  '/room-transfer-list': '/room-transfer/list',
  '/room-transfer-update': '/room-transfer/update',
  '/room-transfer-cancel': '/room-transfer/cancel',
  '/room-transfer-delete': '/room-transfer/delete',

  '/account-groups-create': '/account-groups/create',
  '/account-groups-list': '/account-groups/list',
  '/account-groups-update': '/account-groups/update',
  '/account-groups-cancel': '/account-groups/cancel',
  '/account-groups-delete': '/account-groups/delete',
  '/account-groups-dropdown': '/account-groups/dropdown',

  '/pay-term-create': '/pay-term/create',
  '/pay-term-list': '/pay-term/list',
  '/pay-term-update': '/pay-term/update',
  '/pay-term-cancel': '/pay-term/cancel',
  '/pay-term-delete': '/pay-term/delete',
  '/pay-term-dropdown': '/pay-term/dropdown',

  '/indent-create': '/indent/create',
  '/indent-list': '/indent/list',
  '/indent-ipd-billing-lists': '/indent-ipd-billing/lists',
  '/indent-medicine-issue-lists': '/indent-medicine-issue/lists',
  '/indent-medicine-returns-lists': '/indent-medicine-returns/lists',
  '/indent-authorize': '/indent/authorize',

  '/radiology-template-create': '/radiology-template/create',
  '/radiology-template-list': '/radiology-template/list',
  '/radiology-template-update': '/radiology-template/update',
  '/radiology-template-delete': '/radiology-template/delete',
  '/radiology-template-cancel': '/radiology-template/cancel',
  '/radiology-template-dropdown': '/radiology-template/dropdown',

  '/radiology-room-master-create': '/radiology-room-master/create',
  '/radiology-room-master-dropdown': '/radiology-room-master/dropdown',

  '/radiology-authority-doctor-list': '/radiology-authority-doctor/list',
  '/radiology-authority-doctor-create': '/radiology-authority-doctor/create',
  '/radiology-authority-doctor-update': '/radiology-authority-doctor/update',
  '/radiology-authority-doctor-cancel': '/radiology-authority-doctor/cancel',
  '/radiology-authority-doctor-delete': '/radiology-authority-doctor/delete',
  '/radiology-authority-doctor-dropdown': '/radiology-authority-doctor/dropdown',

  '/radiology-diagnosis-master-list': '/radiology-diagnosis-master/list',
  '/radiology-diagnosis-master-create': '/radiology-diagnosis-master/create',
  '/radiology-diagnosis-master-update': '/radiology-diagnosis-master/update',
  '/radiology-diagnosis-master-cancel': '/radiology-diagnosis-master/cancel',
  '/radiology-diagnosis-master-delete': '/radiology-diagnosis-master/delete',
  '/radiology-diagnosis-master-dropdown': '/radiology-diagnosis-master/dropdown',

  '/service-acknowledgement-create': '/service-acknowledgement/create',
  '/service-acknowledgement-radiology-list': '/service-acknowledgement-radiology/list',
  '/service-acknowledgement-list': '/service-acknowledgement/list',
  '/service-acknowledgement-def': '/service-acknowledgement/def',
  '/service-acknowledgement-cancel': '/service-acknowledgement/cancel',
  '/service-acknowledgement-done': '/service-acknowledgement/done',

  '/radiology-procedure-report-list': '/radiology-procedure-report/list',
  '/radiology-procedure-report-ipd-list': '/radiology-procedure-report-ipd/list',
  '/radiology-procedure-report-create': '/radiology-procedure-report/create',
  '/radiology-procedure-report-update': '/radiology-procedure-report/update',
  '/radiology-procedure-report-cancel': '/radiology-procedure-report/cancel',
  '/radiology-procedure-report-delete': '/radiology-procedure-report/delete',
  '/radiology-procedure-report-authorize': '/radiology-procedure-report/authorize',

  '/indent-medicine-issue-create': '/indent-medicine-issue/create',
  '/indent-medicine-issue-list': '/indent-medicine-issue/list',
  '/indent-medicine-issue-update': '/indent-medicine-issue/update',

  '/indoor-medicine-return-create': '/indoor-medicine-return/create',
  '/indoor-medicine-return-update': '/indoor-medicine-return/update',
  '/indoor-medicine-return-list': '/indoor-medicine-return/list',

  '/room-master-cleaning-status-create': '/room-master-cleaning-status/create',

  '/tray-list': '/tray/list',
  '/tray-create': '/tray/create',
  '/tray-update': '/tray/update',
  '/tray-delete': '/tray/delete',
  '/tray-dropdown': '/tray/dropdown',

  '/tray-request-list': '/tray-request/list',
  '/tray-request-create': '/tray-request/create',

  '/anaesthesia-master-list': '/anaesthesia-master/list',
  '/anaesthesia-master-create': '/anaesthesia-master/create',
  '/anaesthesia-master-update': '/anaesthesia-master/update',
  '/anaesthesia-master-cancel': '/anaesthesia-master/cancel',
  '/anaesthesia-master-delete': '/anaesthesia-master/delete',
  '/anaesthesia-master-dropdown': '/anaesthesia-master/dropdown',

  '/equipment-type-list': '/equipment-type/list',
  '/equipment-type-create': '/equipment-type/create',
  '/equipment-type-update': '/equipment-type/update',
  '/equipment-type-cancel': '/equipment-type/cancel',
  '/equipment-type-delete': '/equipment-type/delete',
  '/equipment-type-dropdown': '/equipment-type/dropdown',

  '/equipment-master-list': '/equipment-master/list',
  '/equipment-master-create': '/equipment-master/create',
  '/equipment-master-update': '/equipment-master/update',
  '/equipment-master-cancel': '/equipment-master/cancel',
  '/equipment-master-delete': '/equipment-master/delete',
  '/equipment-master-dropdown': '/equipment-master/dropdown',

  '/operation-theatre-list': '/operation-theatre/list',
  '/operation-theatre-create': '/operation-theatre/create',
  '/operation-theatre-update': '/operation-theatre/update',
  '/operation-theatre-cancel': '/operation-theatre/cancel',
  '/operation-theatre-delete': '/operation-theatre/delete',
  '/operation-theatre-dropdown': '/operation-theatre/dropdown',

  '/region-master-list': '/region-master/list',
  '/region-master-create': '/region-master/create',
  '/region-master-update': '/region-master/update',
  '/region-master-cancel': '/region-master/cancel',
  '/region-master-delete': '/region-master/delete',
  '/region-master-dropdown': '/region-master/dropdown',

  '/otnotes-list': '/otnotes/list',
  '/otnotes-create': '/otnotes/create',
  '/otnotes-update': '/otnotes/update',
  '/otnotes-cancel': '/otnotes/cancel',
  '/otnotes-delete': '/otnotes/delete',
  '/otnotes-dropdown': '/otnotes/dropdown',

  '/patient-receipt-voucher-create': '/patient-receipt-voucher/create',
  '/patient-receipt-voucher-update': '/patient-receipt-voucher/update',
  '/patient-receipt-voucher-delete': '/patient-receipt-voucher/delete',
  '/patient-receipt-voucher-list': '/patient-receipt-voucher/list',
  '/patient-receipt-voucher-balance': '/patient-receipt-voucher/balance',
  '/patient-pending-balance': '/patient-pending/balance',

  '/ot-schedule-create': '/ot-schedule/create',
  '/ot-schedule-list': '/ot-schedule/list',
  '/ot-schedule-done-list': '/ot-schedule-done/list',
  '/ot-scheduled-lists': '/ot-scheduled/lists',
  '/ot-schedule-cancel': '/ot-schedule/cancel',
  '/ot-schedule-delete': '/ot-schedule/delete',
  '/ot-schedule-edit': '/ot-schedule/edit',
  '/ot-schedule-cancelled': '/ot-schedule/cancelled',
  '/ot-schedule-done': '/ot-schedule/done',

  '/ot-entry-create': '/ot-entry/create',
  '/ot-entry-list': '/ot-entry/list',
  '/ot-entry-cancel': '/ot-entry/cancel',
  '/ot-entry-delete': '/ot-entry/delete',
  '/ot-entry-edit': '/ot-entry/edit',

  '/diagnosis-group-list': '/diagnosis-group/list',
  '/diagnosis-group-create': '/diagnosis-group/create',
  '/diagnosis-group-update': '/diagnosis-group/update',
  '/diagnosis-group-cancel': '/diagnosis-group/cancel',
  '/diagnosis-group-delete': '/diagnosis-group/delete',
  '/diagnosis-group-dropdown': '/diagnosis-group/dropdown',

  '/diagnosis-subgroup-list': '/diagnosis-subgroup/list',
  '/diagnosis-subgroup-create': '/diagnosis-subgroup/create',
  '/diagnosis-subgroup-update': '/diagnosis-subgroup/update',
  '/diagnosis-subgroup-cancel': '/diagnosis-subgroup/cancel',
  '/diagnosis-subgroup-delete': '/diagnosis-subgroup/delete',
  '/diagnosis-subgroup-dropdown': '/diagnosis-subgroup/dropdown',

  '/mrd-diagnosis-list': '/mrd-diagnosis/list',
  '/mrd-diagnosis-create': '/mrd-diagnosis/create',
  '/mrd-diagnosis-update': '/mrd-diagnosis/update',
  '/mrd-diagnosis-cancel': '/mrd-diagnosis/cancel',
  '/mrd-diagnosis-delete': '/mrd-diagnosis/delete',
  '/mrd-diagnosis-dropdown': '/mrd-diagnosis/dropdown',

  '/icp-group-list': '/icp-group/list',
  '/icp-group-create': '/icp-group/create',
  '/icp-group-update': '/icp-group/update',
  '/icp-group-cancel': '/icp-group/cancel',
  '/icp-group-delete': '/icp-group/delete',
  '/icp-group-dropdown': '/icp-group/dropdown',

  '/icp-subgroup-list': '/icp-subgroup/list',
  '/icp-subgroup-create': '/icp-subgroup/create',
  '/icp-subgroup-update': '/icp-subgroup/update',
  '/icp-subgroup-cancel': '/icp-subgroup/cancel',
  '/icp-subgroup-delete': '/icp-subgroup/delete',
  '/icp-subgroup-dropdown': '/icp-subgroup/dropdown',

  '/icp-diagnosis-list': '/icp-diagnosis/list',
  '/icp-diagnosis-create': '/icp-diagnosis/create',
  '/icp-diagnosis-update': '/icp-diagnosis/update',
  '/icp-diagnosis-cancel': '/icp-diagnosis/cancel',
  '/icp-diagnosis-delete': '/icp-diagnosis/delete',
  '/icp-diagnosis-dropdown': '/icp-diagnosis/dropdown',

  '/zone-list': '/zone/list',
  '/zone-create': '/zone/create',
  '/zone-update': '/zone/update',
  '/zone-cancel': '/zone/cancel',
  '/zone-delete': '/zone/delete',
  '/zone-dropdown': '/zone/dropdown',

  '/binn-list': '/binn/list',
  '/binn-create': '/binn/create',
  '/binn-update': '/binn/update',
  '/binn-cancel': '/binn/cancel',
  '/binn-delete': '/binn/delete',
  '/binn-dropdown': '/binn/dropdown',

  '/mlc-type-list': '/mlc-type/list',
  '/mlc-type-create': '/mlc-type/create',
  '/mlc-type-update': '/mlc-type/update',
  '/mlc-type-cancel': '/mlc-type/cancel',
  '/mlc-type-delete': '/mlc-type/delete',
  '/mlc-type-dropdown': '/mlc-type/dropdown',

  '/junior-resident-list': '/junior-resident/list',
  '/junior-resident-create': '/junior-resident/create',
  '/junior-resident-update': '/junior-resident/update',
  '/junior-resident-cancel': '/junior-resident/cancel',
  '/junior-resident-delete': '/junior-resident/delete',
  '/junior-resident-dropdown': '/junior-resident/dropdown',

  '/deficiency-checklist-list': '/deficiency-checklist/list',
  '/deficiency-checklist-create': '/deficiency-checklist/create',
  '/deficiency-checklist-update': '/deficiency-checklist/update',
  '/deficiency-checklist-cancel': '/deficiency-checklist/cancel',
  '/deficiency-checklist-delete': '/deficiency-checklist/delete',
  '/deficiency-checklist-dropdown': '/deficiency-checklist/dropdown',

  '/component-list': '/component/list',
  '/component-create': '/component/create',
  '/component-update': '/component/update',
  '/component-cancel': '/component/cancel',
  '/component-delete': '/component/delete',
  '/component-dropdown': '/component/dropdown',

  '/unit-list': '/unit/list',
  '/unit-create': '/unit/create',
  '/unit-update': '/unit/update',
  '/unit-cancel': '/unit/cancel',
  '/unit-delete': '/unit/delete',
  '/unit-dropdown': '/unit/dropdown',

  '/blood-bank-group-list': '/blood-bank-group/list',
  '/blood-bank-group-create': '/blood-bank-group/create',
  '/blood-bank-group-update': '/blood-bank-group/update',
  '/blood-bank-group-cancel': '/blood-bank-group/cancel',
  '/blood-bank-group-delete': '/blood-bank-group/delete',
  '/blood-bank-group-dropdown': '/blood-bank-group/dropdown',

  '/blood-bank-master-list': '/blood-bank-master/list',
  '/blood-bank-master-create': '/blood-bank-master/create',
  '/blood-bank-master-update': '/blood-bank-master/update',
  '/blood-bank-master-cancel': '/blood-bank-master/cancel',
  '/blood-bank-master-delete': '/blood-bank-master/delete',
  '/blood-bank-master-dropdown': '/blood-bank-master/dropdown',

  '/blood-type-list': '/blood-type/list',
  '/blood-type-create': '/blood-type/create',
  '/blood-type-update': '/blood-type/update',
  '/blood-type-cancel': '/blood-type/cancel',
  '/blood-type-delete': '/blood-type/delete',
  '/blood-type-dropdown': '/blood-type/dropdown',

  '/deficiency-checklists-create': '/deficiency-checklists/create',
  '/deficiency-checklists-patient-list': '/deficiency-checklists-patient/list',

  '/store-product-master-create': '/store-product-master/create',
  '/store-product-master-list': '/store-product-master/list',
  '/store-product-master-update': '/store-product-master/update',
  '/store-product-master-delete': '/store-product-master/delete',
  '/store-product-master-cancel': '/store-product-master/cancel',
  '/store-product-master-dropdown': '/store-product-master/dropdown',

  '/store-grn-create': '/store-grn/create',
  '/store-grn-list': '/store-grn/list',
  '/store-grn-update': '/store-grn/update',
  '/store-grn-cancel': '/store-grn/cancel',
  '/store-grn-delete': '/store-grn/delete',
  '/store-grn-dropdown': '/store-grn/dropdown',
  '/store-grn-unauthorise-dropdown': '/store-grn-unauthorise/dropdown',

  '/store-consignment-receipt-create': '/store-consignment-receipt/create',
  '/store-consignment-receipt-list': '/store-consignment-receipt/list',
  '/store-consignment-receipt-update': '/store-consignment-receipt/update',
  '/store-consignment-receipt-cancel': '/store-consignment-receipt/cancel',
  '/store-consignment-receipt-delete': '/store-consignment-receipt/delete',
  '/store-consignment-receipt-dropdown': '/store-consignment-receipt/dropdown',
  '/store-consignment-receipt-unauthorise-dropdown': '/store-consignment-receipt-unauthorise/dropdown',

  '/store-stock-master-create': '/store-stock-master/create',
  '/store-stock-master-list': '/store-stock-master/list',
  '/store-stock-master-dropdown': '/store-stock-master/dropdown',
  '/store-stock-master-adddetail-dropdown': '/store-stock-master/adddetail/dropdown',
  '/store-stock-master-details-dropdown': '/store-stock-master-details/dropdown',
  '/stock-master-product-consumption': '/stock-master-product/consumption',

  '/store-consignment-return-create': '/store-consignment-return/create',
  '/store-consignment-return-list': '/store-consignment-return/list',
  '/store-consignment-return-update': '/store-consignment-return/update',
  '/store-consignment-return-delete': '/store-consignment-return/delete',
  '/store-consignment-return-cancel': '/store-consignment-return/cancel',
  '/store-consignment-return-dropdown': '/store-consignment-return/dropdown',

  '/store-purchase-return-create': '/store-purchase-return/create',
  '/store-purchase-return-list': '/store-purchase-return/list',
  '/store-purchase-return-update': '/store-purchase-return/update',
  '/store-purchase-return-cancel': '/store-purchase-return/cancel',
  '/store-purchase-return-delete': '/store-purchase-return/delete',

  '/warehouse-stock-request-create': '/warehouse-stock-request/create',
  '/warehouse-stock-request-list': '/warehouse-stock-request/list',
  '/warehouse-stock-request-dropdown': '/warehouse-stock-request/dropdown',
  '/warehouse-stock-request-unauthorise-dropdown': '/warehouse-stock-request-unauthorise/dropdown',
  '/warehouse-stock-request-update': '/warehouse-stock-request/update',
  '/warehouse-stock-request-authorise': '/warehouse-stock-request/authorise',
  '/warehouse-stock-request-cancel': '/warehouse-stock-request/cancel',
  '/warehouse-stock-request-delete': '/warehouse-stock-request/delete',
  '/requested-warehouse-stock-request-list': '/requested-warehouse-stock-request/list',

  '/voucher-series-setup-create': '/voucher-series-setup/create',
  '/voucher-series-setup-list': '/voucher-series-setup/list',
  '/voucher-series-setup-update': '/voucher-series-setup/update',
  '/voucher-series-setup-cancel': '/voucher-series-setup/cancel',
  '/voucher-series-setup-delete': '/voucher-series-setup/delete',

  '/price-list-master-create': '/price-list-master/create',
  '/price-list-master-dropdown': '/price-list-master/dropdown',
  '/price-list-master-list': '/price-list-master/list',

  '/lab-price-list-master-create': '/lab-price-list-master/create',
  '/lab-price-list-master-dropdown': 'lab-/price-list-master/dropdown',
  '/lab-price-list-master-list': '/lab-price-list-master/list',

  '/ipd-requisition-create': '/ipd-requisition/create',
  '/ipd-requisition-list': '/ipd-requisition/list',
  '/ipd-requisition-cancel': '/ipd-requisition/cancel',
  '/ipd-requisition-delete': '/ipd-requisition/delete',
  '/ipd-requisition-edit': '/ipd-requisition/edit',

  '/purchase-order-create': '/purchase-order/create',
  '/purchase-order-list': '/purchase-order/list',
  '/purchase-order-update': '/purchase-order/update',
  '/purchase-order-cancel': '/purchase-order/cancel',
  '/purchase-order-delete': '/purchase-order/delete',
  '/purchase-order-supplier-drodpown': '/purchase-order-supplier/drodpown',

  '/purchase-order-term-list': '/purchase-order-term/list',
  '/purchase-order-term-create': '/purchase-order-term/create',
  '/purchase-order-term-update': '/purchase-order-term/update',
  '/purchase-order-term-delete': '/purchase-order-term/delete',
  '/purchase-order-term-cancel': '/purchase-order-term/cancel',
  '/purchase-order-term-dropdown': '/purchase-order-term/dropdown',

  '/stock-transfer-voucher-create': '/stock-transfer-voucher/create',
  '/stock-transfer-voucher-approve': '/stock-transfer-voucher/approve',
  '/stock-transfer-voucher-list': '/stock-transfer-voucher/list',
  '/stock-transfer-voucher-update': '/stock-transfer-voucher/update',
  '/stock-transfer-voucher-not-approved-list': '/stock-transfer-voucher-not-approved/list',

  '/diet-management-create': '/diet-management/create',
  '/diet-management-detail': '/diet-management/detail',

  '/employee-department-create': '/employee-department/create',
  '/employee-department-dropdown': '/employee-department/dropdown',
  '/employee-department-list': '/employee-department/list',
  '/employee-department-update': '/employee-department/update',
  '/employee-department-cancel': '/employee-department/cancel',
  '/employee-department-delete': '/employee-department/delete',

  '/employee-role-create': '/employee-role/create',
  '/employee-role-dropdown': '/employee-role/dropdown',
  '/employee-role-list': '/employee-role/list',
  '/employee-role-update': '/employee-role/update',
  '/employee-role-cancel': '/employee-role/cancel',
  '/employee-role-delete': '/employee-role/delete',

  '/employee-shift-create': '/employee-shift/create',
  '/employee-shift-dropdown': '/employee-shift/dropdown',
  '/employee-shift-list': '/employee-shift/list',
  '/employee-shift-update': '/employee-shift/update',
  '/employee-shift-cancel': '/employee-shift/cancel',
  '/employee-shift-delete': '/employee-shift/delete',

  '/employee-create': '/employee/create',
  '/employee-list': '/employee/list',
  '/employee-update': '/employee/update',
  '/employee-cancel': '/employee/cancel',
  '/employee-delete': '/employee/delete',

  '/blood-intake-create': '/blood-intake/create',
  '/blood-intake-list': '/blood-intake/list',
  '/blood-intake-expiry-date-price-list': '/blood-intake-expiry-date-price/list',
  '/blood-intake-component-details-list': '/blood-intake-component-details/list',
  '/blood-intake-cancel': '/blood-intake/cancel',
  '/blood-intake-delete': '/blood-intake/delete',
  '/blood-intake-edit': '/blood-intake/edit',

  '/blood-request-create': '/blood-request/create',
  '/blood-request-list': '/blood-request/list',
  '/blood-requested-list': '/blood-requested/list',
  '/blood-request-cancel': '/blood-request/cancel',
  '/blood-request-status-cancel': '/blood-request-status/cancel',
  '/blood-request-status-crossmatch': '/blood-request-status/crossmatch',
  '/blood-request-status-donor': '/blood-request-status/donor',
  '/blood-request-status-issue': '/blood-request-status/issue',
  '/blood-request-delete': '/blood-request/delete',
  '/blood-request-edit': '/blood-request/edit',

  '/donor-create': '/donor/create',
  '/donor-update': '/donor/update',
  '/donor-cancel': '/donor/cancel',
  '/donor-delete': '/donor/delete',
  '/donor-list': '/donor/list',
  '/donor-dropdown': '/donor/dropdown',
  '/donor-calculate-total-credit': '/donor/calculate-total-credit',

  '/nurse-blood-request-create': '/nurse-blood-request/create',
  '/nurse-blood-request-list': '/nurse-blood-request/list',
  '/nurse-blood-requested-list': '/nurse-blood-requested/list',
  '/nurse-blood-request-cancel': '/nurse-blood-request/cancel',
  '/nurse-blood-request-delete': '/nurse-blood-request/delete',
  '/nurse-blood-request-edit': '/nurse-blood-request/edit',
  '/nurse-blood-request-status-cancel': '/nurse-blood-request-status/cancel',
  '/nurse-blood-request-status-crossmatch': '/nurse-blood-request-status/crossmatch',
  '/nurse-blood-request-status-donor': '/nurse-blood-request-status/donor',
  '/nurse-blood-request-status-issue': '/nurse-blood-request-status/issue',

  '/ivf-patient-history-create': '/ivf-patient-history/create',
  '/ivf-patient-history-detail': '/ivf-patient-history/detail',
  '/ivf-patient-history-all': '/ivf-patient-history/all',
  '/ivf-patient-history-update': '/ivf-patient-history/update',
  '/ivf-patient-history-cancel': '/ivf-patient-history/cancel',
  '/ivf-patient-history-delete': '/ivf-patient-history/delete',

  '/ivf-treatement-create': '/ivf-treatement/create',
  '/ivf-treatement-all': '/ivf-treatement/all',
  '/ivf-treatement-update': '/ivf-treatement/update',
  '/ivf-treatement-cancel': '/ivf-treatement/cancel',
  '/ivf-treatement-delete': '/ivf-treatement/delete',

  '/admission-type-list': '/admission-type/list',
  '/admission-type-create': '/admission-type/create',
  '/admission-type-update': '/admission-type/update',
  '/admission-type-delete': '/admission-type/delete',
  '/admission-type-cancel': '/admission-type/cancel',
  '/admission-type-dropdown': '/admission-type/dropdown',

  '/store-purchase-order-create': '/store-purchase-order/create',
  '/store-purchase-order-list': '/store-purchase-order/list',
  '/store-purchase-order-update': '/store-purchase-order/update',
  '/store-purchase-order-cancel': '/store-purchase-order/cancel',
  '/store-purchase-order-delete': '/store-purchase-order/delete',

  '/store-manufacturer-create': '/store-manufacturer/create',
  '/store-manufacturer-list': '/store-manufacturer/list',
  '/store-manufacturer-update': '/store-manufacturer/update',
  '/store-manufacturer-cancel': '/store-manufacturer/cancel',
  '/store-manufacturer-delete': '/store-manufacturer/delete',
  '/store-manufacturer-dropdown': '/store-manufacturer/dropdown',

  '/store-product-category-create': '/store-product-category/create',
  '/store-product-category-list': '/store-product-category/list',
  '/store-product-category-update': '/store-product-category/update',
  '/store-product-category-cancel': '/store-product-category/cancel',
  '/store-product-category-delete': '/store-product-category/delete',
  '/store-product-category-dropdown': '/store-product-category/dropdown',

  '/store-group-create': '/store-group/create',
  '/store-group-list': '/store-group/list',
  '/store-group-update': '/store-group/update',
  '/store-group-dropdown': '/store-group/dropdown',
  '/store-group-delete': '/store-group/delete',
  '/store-group-cancel': '/store-group/cancel',

  '/store-subgroup-create': '/store-subgroup/create',
  '/store-subgroup-list': '/store-subgroup/list',
  '/store-subgroup-update': '/store-subgroup/update',
  '/store-subgroup-dropdown': '/store-subgroup/dropdown',
  '/store-subgroup-cancel': '/store-subgroup/cancel',
  '/store-subgroup-delete': '/store-subgroup/delete',

  '/store-marketed-create': '/store-marketed/create',
  '/store-marketed-list': '/store-marketed/list',
  '/store-marketed-update': '/store-marketed/update',
  '/store-marketed-dropdown': '/store-marketed/dropdown',
  '/store-marketed-cancel': '/store-marketed/cancel',
  '/store-marketed-delete': '/store-marketed/delete',

  '/store-purchase-uom-create': '/store-purchase-uom/create',
  '/store-purchase-uom-list': '/store-purchase-uom/list',
  '/store-purchase-uom-update': '/store-purchase-uom/update',
  '/store-purchase-uom-dropdown': '/store-purchase-uom/dropdown',
  '/store-purchase-uom-cancel': '/store-purchase-uom/cancel',
  '/store-purchase-uom-delete': '/store-purchase-uom/delete',

  '/store-uqc-master-create': '/store-uqc-master/create',
  '/store-uqc-master-list': '/store-uqc-master/list',
  '/store-uqc-master-update': '/store-uqc-master/update',
  '/store-uqc-master-dropdown': '/store-uqc-master/dropdown',
  '/store-uqc-master-cancel': '/store-uqc-master/cancel',
  '/store-uqc-master-delete': '/store-uqc-master/delete',

  '/store-tax-category-master-create': '/store-tax-category-master/create',
  '/store-tax-category-master-list': '/store-tax-category-master/list',
  '/store-tax-category-master-update': '/store-tax-category-master/update',
  '/store-tax-category-master-dropdown': '/store-tax-category-master/dropdown',
  '/store-tax-category-master-cancel': '/store-tax-category-master/cancel',
  '/store-tax-category-master-delete': '/store-tax-category-master/delete',

  '/radiology-service-booking-create': '/radiology-service-booking/create',
  '/radiology-service-booking-list': '/radiology-service-booking/list',
  '/radiology-service-booking-acknowledgement-list': '/radiology-service-booking-acknowledgement/list',
  '/radiology-service-booking-cancel': '/radiology-service-booking/cancel',
  '/radiology-service-booking-delete': '/radiology-service-booking/delete',
  '/radiology-service-booking-edit': '/radiology-service-booking/edit',

  '/physiotherapy-service-master-create': '/physiotherapy-service-master/create',
  '/physiotherapy-service-master-list': '/physiotherapy-service-master/list',
  '/physiotherapy-service-master-edit': '/physiotherapy-service-master/edit',
  '/physiotherapy-service-master-delete': '/physiotherapy-service-master/delete',

  '/physiotherapy-booking-create': '/physiotherapy-booking/create',
  '/physiotherapy-booking-list': '/physiotherapy-booking/list',
  '/physiotherapy-booking-edit': '/physiotherapy-booking/edit',
  '/physiotherapy-booking-cancel': '/physiotherapy-booking/cancel',
  '/physiotherapy-booking-delete': '/physiotherapy-booking/delete',
  '/physiotherapy-booking-detail': '/physiotherapy-booking/detail',
  '/physiotherapy-booking-report': '/physiotherapy-booking/report',

  '/discharge-summary-template-master-create': '/discharge-summary-template-master/create',
  '/discharge-summary-template-master-list': '/discharge-summary-template-master/list',
  '/discharge-summary-template-master-update': '/discharge-summary-template-master/update',
  '/discharge-summary-template-master-cancel': '/discharge-summary-template-master/cancel',
  '/discharge-summary-template-master-delete': '/discharge-summary-template-master/delete',

  '/ot-patient-transfer-create': '/ot-patient-transfer/create',

  '/user-wise-doctor-mapping-create': '/user-wise-doctor-mapping/create',
  '/user-wise-doctor-mapping-list': '/user-wise-doctor-mapping/list',
  '/user-wise-doctor-mapping-update': '/user-wise-doctor-mapping/update',
  '/user-wise-doctor-mapping-dropdown': '/user-wise-doctor-mapping/dropdown',

  '/lab-user-authority-master-list': '/lab-user-authority-master/list',
  '/lab-user-authority-master-create': '/lab-user-authority-master/create',
  '/lab-user-authority-master-update': '/lab-user-authority-master/update',
  '/lab-user-authority-master-cancel': '/lab-user-authority-master/cancel',
  '/lab-user-authority-master-delete': '/lab-user-authority-master/delete',
  '/lab-user-authority-master-dropdown': '/lab-user-authority-master/dropdown',
  '/lab-user-authority-master-deactivate': '/lab-user-authority-master/deactivate',

  '/user-wise-warehouse-mapping-create': '/user-wise-warehouse-mapping/create',
  '/user-wise-warehouse-mapping-list': '/user-wise-warehouse-mapping/list',
  '/user-wise-warehouse-mapping-update': '/user-wise-warehouse-mapping/update',
  '/user-wise-warehouse-mapping-cancel': '/user-wise-warehouse-mapping/cancel',
  '/user-wise-warehouse-mapping-delete': '/user-wise-warehouse-mapping/delete',
  '/user-wise-warehouse-mapping-dropdown': '/user-wise-warehouse-mapping/dropdown',

  '/stock-transfer-voucher-accept-create': '/stock-transfer-voucher-accept/create',
  '/stock-transfer-voucher-accept-list': '/stock-transfer-voucher-accept/list',

  '/expense-head-master-create': '/expense-head-master/create',
  '/expense-head-master-list': '/expense-head-master/list',
  '/expense-head-master-update': '/expense-head-master/update',
  '/expense-head-master-cancel': '/expense-head-master/cancel',
  '/expense-head-master-delete': '/expense-head-master/delete',
  '/expense-head-master-dropdown': '/expense-head-master/dropdown',

  '/echs-referral-create': '/echs-referral/create',
  '/echs-referral-list': '/echs-referral/list',
  '/echs-referral-update': '/echs-referral/update',
  '/echs-referral-cancel': '/echs-referral/cancel',
  '/echs-referral-delete': '/echs-referral/delete',

  '/visit-type-master-create': '/visit-type-master/create',
  '/visit-type-master-list': '/visit-type-master/list',
  '/visit-type-master-update': '/visit-type-master/update',
  '/visit-type-master-cancel': '/visit-type-master/cancel',
  '/visit-type-master-delete': '/visit-type-master/delete',
  '/visit-type-master-dropdown': '/visit-type-master/dropdown',

  '/stock-adjustment-create': '/stock-adjustment/create',
  '/stock-adjustment-list': '/stock-adjustment/list',
  '/stock-adjustment-update': '/stock-adjustment/update',
  '/stock-adjustment-cancel': '/stock-adjustment/cancel',
  '/stock-adjustment-delete': '/stock-adjustment/delete',
  '/stock-adjustment-authorise': '/stock-adjustment/authorise',

  '/purchase-requisition-create': '/purchase-requisition/create',
  '/purchase-requisition-list': '/purchase-requisition/list',
  '/purchase-requisition-update': '/purchase-requisition/update',
  '/purchase-requisition-cancel': '/purchase-requisition/cancel',
  '/purchase-requisition-delete': '/purchase-requisition/delete',

  '/update-batch-create': '/update-batch/create',

  '/tpa-claim-amount-create': '/tpa-claim-amount/create',
  '/tpa-claim-amount-list': '/tpa-claim-amount/list',
  '/tpa-claim-amount-update': '/tpa-claim-amount/update',
  '/tpa-claim-amount-delete': '/tpa-claim-amount/delete',
  '/tpa-claim-amount-cancel': '/tpa-claim-amount/cancel',

  '/total-expired-items': '/total-expired-items',
  '/total-stock-status': '/total-stock-status',
  '/total-revenue': '/total-revenue',
  '/total-purchase': '/total-purchase',
  '/total-sales': '/total-sales',
  '/total-sales-paymode': '/total-sales-paymode',
  '/total-expired-products-list': '/total-expired-products/list',
  '/top-selling-product-list': '/top-selling-product/list',
  '/least-selling-product-list': '/least-selling-product/list',

  '/ipd-indent-cancel-create': '/ipd-indent-cancel/create',
  '/ipd-indent-cancel-list': '/ipd-indent-cancel/list',


  '/patient-wise-consumption-create': '/patient-wise-consumption/create',
  '/patient-wise-consumption-list': '/patient-wise-consumption/list',
  '/patient-wise-consumption-update': '/patient-wise-consumption/update',


  '/expense-entry-create': '/expense-entry/create',
  '/expense-entry-list': '/expense-entry/list',
  '/expense-entry-update': '/expense-entry/update',
  '/expense-entry-delete': '/expense-entry/delete',
  '/expense-entry-cancel': '/expense-entry/cancel',



  '/authority-master-list': '/authority-master/list',
  '/authority-master-create': '/authority-master/create',
  '/authority-master-update': '/authority-master/update',
  '/authority-master-cancel': '/authority-master/cancel',
  '/authority-master-delete': '/authority-master/delete',
  '/authority-master-dropdown': '/authority-master/dropdown',

  '/partial-cancellation-opd-billing-create': '/partial-cancellation-opd-billing/create',
  '/partial-cancellation-ipd-billing-create': '/partial-cancellation-ipd-billing/create',
  '/partial-cancellation-list': '/partial-cancellation/list',


  '/ward-wise-consultant-visit-charges-list': '/ward-wise-consultant-visit-charges/list',
  '/ward-wise-consultant-visit-charges-create': '/ward-wise-consultant-visit-charges/create',
  '/ward-wise-consultant-visit-charges-update': '/ward-wise-consultant-visit-charges/update',
  '/ward-wise-consultant-visit-charges-cancel': '/ward-wise-consultant-visit-charges/cancel',
  '/ward-wise-consultant-visit-charges-delete': '/ward-wise-consultant-visit-charges/delete',
  '/consultant-ward-charge': '/consultant-ward/charge',


  '/consultant-visiting-create': '/consultant-visiting/create',
  '/consultant-visiting-list': '/consultant-visiting/list',
  '/consultant-visiting-update': '/consultant-visiting/update',
  '/consultant-visiting-cancel': '/consultant-visiting/cancel',
  '/consultant-visiting-delete': '/consultant-visiting/delete',

};

Object.freeze(API_MAP);
export { API_MAP };
